export const basic3 = () => ({
  type: 'page',
  meta: {
    id: 'doc:home',
    title: '3 section page',
    createDate: 1706097380427,
    tags: [],
  },
  blocks: {
    type: 'block',
    id: 'uissupJ2WT',
    flavour: 'affine:page',
    version: 2,
    props: {
      title: {
        '$blocksuite:internal:text$': true,
        delta: [
          {
            insert: '3 section page',
          },
        ],
      },
    },
    children: [
      {
        type: 'block',
        id: 'd0K06-mlZL',
        flavour: 'affine:surface',
        version: 5,
        props: {
          elements: {
            '9YhHZGet1b': {
              index: 'a1',
              seed: 316817222,
              xywh: '[-635.5351562500001,173.5768229166668,400.32386779785156,49.5]',
              rotate: 0,
              text: {
                'affine:surface:text': true,
                delta: [
                  {
                    insert: 'section1.title',
                  },
                ],
              },
              color: '--affine-palette-line-white',
              fontSize: 36,
              fontFamily: 'blocksuite:surface:Poppins',
              fontWeight: '400',
              fontStyle: 'normal',
              textAlign: 'left',
              type: 'text',
              id: '9YhHZGet1b',
              hasMaxWidth: false,
            },
            ZzIrg_E8gy: {
              index: 'a2',
              seed: 316817222,
              xywh: '[-90.17708333333337,173.5768229166668,400,50]',
              rotate: 0,
              text: {
                'affine:surface:text': true,
                delta: [
                  {
                    insert: 'section2.title',
                  },
                ],
              },
              color: '--affine-palette-line-black',
              fontSize: 36,
              fontFamily: 'blocksuite:surface:Poppins',
              fontWeight: '400',
              fontStyle: 'normal',
              textAlign: 'left',
              type: 'text',
              id: 'ZzIrg_E8gy',
              hasMaxWidth: false,
            },
            cUDyd4HRaZ: {
              index: 'a3',
              seed: 316817222,
              xywh: '[517.6419270833334,173.5768229166668,400,50]',
              rotate: 0,
              text: {
                'affine:surface:text': true,
                delta: [
                  {
                    insert: 'section3.title',
                  },
                ],
              },
              color: '--affine-palette-line-black',
              fontSize: 36,
              fontFamily: 'blocksuite:surface:Poppins',
              fontWeight: '400',
              fontStyle: 'normal',
              textAlign: 'left',
              type: 'text',
              id: 'cUDyd4HRaZ',
              hasMaxWidth: false,
            },
          },
        },
        children: [
          {
            type: 'block',
            id: 'fi_5CTvxEl',
            flavour: 'affine:image',
            version: 1,
            props: {
              caption: 'background',
              sourceId: 'jUWhY-NGGMfAIspiaWG3PshhUybAyIzezqB4O9YDGFM=',
              width: 1920,
              height: 1080,
              index: 'a0',
              xywh: '[-778.4609375,-135.55078125,1920,1080]',
              rotate: 0,
              size: 44228,
            },
            children: [],
          },
          {
            type: 'block',
            id: 'y23t_-O3yd',
            flavour: 'affine:frame',
            version: 1,
            props: {
              title: {
                '$blocksuite:internal:text$': true,
                delta: [
                  {
                    insert: 'title',
                  },
                ],
              },
              background: '--affine-palette-transparent',
              xywh: '[-818.4609375,-175.55078125,2000,1160]',
              index: 'a0',
            },
            children: [],
          },
        ],
      },
      {
        type: 'block',
        id: 'Vg13f_xu5o',
        flavour: 'affine:note',
        version: 1,
        props: {
          xywh: '[-659.714488636364,295.3927556818182,459.1659564393938,585.5933948863637]',
          background: '--affine-palette-transparent',
          index: 'a0V',
          hidden: false,
          displayMode: 'edgeless',
          edgeless: {
            style: {
              borderRadius: 8,
              borderSize: 4,
              borderStyle: 'none',
              shadowType: '',
            },
            scale: 1,
            collapse: true,
            collapsedHeight: 585.5933948863637,
          },
        },
        children: [
          {
            type: 'block',
            id: '_CW9bgBGNP',
            flavour: 'affine:paragraph',
            version: 1,
            props: {
              type: 'text',
              text: {
                '$blocksuite:internal:text$': true,
                delta: [
                  {
                    insert: 'section1.content',
                  },
                ],
              },
            },
            children: [],
          },
        ],
      },
      {
        type: 'block',
        id: 'SKtPg-avYF',
        flavour: 'affine:note',
        version: 1,
        props: {
          xywh: '[-113.34079071969722,275.80291193181813,448.4107481060605,585.5933948863637]',
          background: '--affine-palette-transparent',
          index: 'a0l',
          hidden: false,
          displayMode: 'edgeless',
          edgeless: {
            style: {
              borderRadius: 8,
              borderSize: 4,
              borderStyle: 'none',
              shadowType: '',
            },
            scale: 1,
            collapse: true,
            collapsedHeight: 585.5933948863637,
          },
        },
        children: [
          {
            type: 'block',
            id: 'GSho_xitFi',
            flavour: 'affine:paragraph',
            version: 1,
            props: {
              type: 'text',
              text: {
                '$blocksuite:internal:text$': true,
                delta: [
                  {
                    insert: 'section2.content',
                  },
                ],
              },
            },
            children: [],
          },
        ],
      },
      {
        type: 'block',
        id: '2y2qdK9wDh',
        flavour: 'affine:note',
        version: 1,
        props: {
          xywh: '[466.1188446969695,275.80291193181813,448.4107481060605,585.5933948863637]',
          background: '--affine-palette-transparent',
          index: 'a0t',
          hidden: false,
          displayMode: 'edgeless',
          edgeless: {
            style: {
              borderRadius: 8,
              borderSize: 4,
              borderStyle: 'none',
              shadowType: '',
            },
            scale: 1,
            collapse: true,
            collapsedHeight: 585.5933948863637,
          },
        },
        children: [
          {
            type: 'block',
            id: 'ZBFIrzfWcQ',
            flavour: 'affine:paragraph',
            version: 1,
            props: {
              type: 'text',
              text: {
                '$blocksuite:internal:text$': true,
                delta: [
                  {
                    insert: 'section3.content',
                  },
                ],
              },
            },
            children: [],
          },
        ],
      },
    ],
  },
});
